import { get, post } from "../libs/https";
const publicPath = process.env.BASE_URL;

export const getAccountOfficers = async () => {
    return await get(`${publicPath}api/officers`);
};

export const assignOfficer = async (id, officerGUID) => {
    return await post(`${publicPath}api/officer/${id}`, {officerGUID});
};

export const getLoanOfficer = async (id) => {
    return await get(`${publicPath}api/officer/${id}`);
};